import cloneDeep from 'lodash/cloneDeep';
import {
  REQUEST_DOWNLOAD_REPORTS,
  REQUEST_DOWNLOAD_REPORT,
  RESPONSE_DOWNLOAD_REPORT,
  REQUEST_DOWNLOAD_REPORT_FAILURE,
  CLEAR_DOWNLOAD_REPORTS
} from './../actions/downloadReportsActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  data: [],
  errors: [],
  format: null
}

const downloadReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DOWNLOAD_REPORTS: {
      let { report, selectedCars, format } = action.payload
      let downloadedReports = []
      if (report.length) {
        report.map((reportItem) => {
          let downloadedReport = {
            reportId: reportItem.id,
            reportTitle: reportItem.title,
            cars: selectedCars.map((carItem) => {
              return {
                id: carItem.id,
                name: carItem.name,
                registerNumber: carItem.registerNumber,
                dataState: states.NOT_REQUESTED
              }
            })
          }

          downloadedReports.push(downloadedReport)
        })
      } else {
        let downloadedReport = {
          reportId: report.id,
          reportTitle: report.title,
          cars: selectedCars.map((item) => {
            return {
              id: item.id,
              name: item.name,
              registerNumber: item.registerNumber,
              dataState: states.NOT_REQUESTED
            }
          })
        }

        downloadedReports.push(downloadedReport)
      }

      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST,
          data: downloadedReports,
          format: format
        }
      )
    }
    case REQUEST_DOWNLOAD_REPORT: {
      let { reportId, carId } = action.payload
      let nextState = cloneDeep(state)
      let downloadedReports = nextState.data
      let reportReady = downloadedReports.find(item => item.reportId === reportId)
      let carReady = reportReady.cars.find(item => item.id === carId)
      carReady.dataState = states.REQUEST

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    case RESPONSE_DOWNLOAD_REPORT: {
      let { reportId, carId } = action.payload
      let nextState = cloneDeep(state)
      let downloadedReports = nextState.data
      let reportReady = downloadedReports.find(item => item.reportId === reportId)
      let carReady = reportReady.cars.find(item => item.id === carId)
      carReady.dataState = states.READY

      if (downloadedReports.every(
        reportItem => reportItem.cars.every(
          carItem => carItem.dataState === states.READY
        )
      )) {
        nextState.dataState = states.READY
      }

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    case REQUEST_DOWNLOAD_REPORT_FAILURE: {
      let { reportId, carId, errors } = action.payload
      let nextState = cloneDeep(state)
      let downloadedReports = nextState.data
      let reportReady = downloadedReports.find(item => item.reportId === reportId)
      let carReady = reportReady.cars.find(item => item.id === carId)
      carReady.dataState = states.FAILURE
      carReady.errors = errors

      if (downloadedReports.some(
        reportItem => reportItem.cars.some(
          carItem => carItem.dataState === states.FAILURE
        )
      )) {
        nextState.dataState = states.FAILURE
      }

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    case CLEAR_DOWNLOAD_REPORTS: {
      return Object.assign(
        {},
        state,
        initialState
      )
    }
    default:
      return state
  }
}

export default downloadReportsReducer